import { render, staticRenderFns } from "./QbClassSelector.vue?vue&type=template&id=21f52fab&"
import script from "./QbClassSelector.vue?vue&type=script&lang=js&"
export * from "./QbClassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports